/**
 * Read one live manuscript page.
 *
 * Accidentals are deliberately not inferred from extra Pencil shapes here. A
 * sharp is four separate strokes and a flat's loop is the same geometry as a
 * small notehead; both proved unreliable on real glass. The writing surface
 * recognises noteheads quickly and lets the learner set ♮, ♯ or ♭ from the note
 * inspector. The lower-level recogniser keeps its full notation grammar for
 * imported fixtures and theory tests.
 */

import type { Stroke } from './types';
import { recognize, type RecognitionResult, type RecognizeOptions } from './recognize';

export interface PageReading extends RecognitionResult {
  /** Retained for saved-page compatibility; live gesture commands are retired. */
  gestures: never[];
  /** No Pencil stroke is consumed as a command in the live manuscript. */
  consumedStrokeIds: string[];
}

export function readPage(strokes: Stroke[], options: RecognizeOptions): PageReading {
  return {
    ...recognize(strokes, { ...options, handwrittenAccidentals: false }),
    gestures: [],
    consumedStrokeIds: [],
  };
}
